// Persists the /applications list "view" (active tab, page, search, filters)
// for the current browser session, so returning from /application-show/:id
// restores the exact page the user was on instead of resetting to page 1.
//
// Session-scoped on purpose: a browsing position should not survive a tab
// close. The app's <router-view :key="$route.fullPath"> fully re-mounts the
// list on every navigation, so the state cannot live in component memory and
// must NOT live in the URL query (that would remount the list on every page
// change). sessionStorage is the right home.

// NOTE: the stored `tab` is a POSITIONAL INDEX into the tab strip, not a stable
// identifier. Any insert/remove in the /applications tab strip therefore
// invalidates every previously-persisted value: an index saved under the old
// layout would silently restore a DIFFERENT tab after the change.
//
// The key is versioned for exactly that reason — bump the suffix whenever the tab
// order changes. An unknown key simply reads as "nothing saved", so stale indices
// are dropped and the user lands on JAMI instead of an arbitrary wrong tab.
// v2: inserted the DTM tab at index 2 (after TO'LIQ BO'LGAN), shifting 8 tabs.
// v3: inserted the MAGISTRATURA tab at index 3 (after DTM), shifting 8 tabs again.
// v4: inserted the IKKINCHI MUTAXASSISLIK tab at index 4 (after MAGISTRATURA), shifting 8 tabs again.
const KEY = "applications.listView.v4";

export function saveListView(view) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(view));
  } catch (_) { /* quota / private mode — silent */ }
}

export function loadListView() {
  let raw;
  try { raw = sessionStorage.getItem(KEY); } catch (_) { return null; }
  if (!raw) return null;
  try { return JSON.parse(raw); } catch (_) { return null; }
}
